module.exports = __webpack_public_path__ + "static/media/button-apple-store.fee04671.svg";